module.exports = __webpack_public_path__ + "static/media/HeroJellyFish.b0603ce2.jpg";